import config from '@/config'

// 统一的 API 配置
export const getBaseUrl = () => {
  const NODE_ENV = process.env.NODE_ENV;
  if (NODE_ENV === "development") {
    return config.baseUrl.dev || "https://www.smartmtm.com/api";
  } else {
    return config.baseUrl.pro || "/api/";
  }
};

// 导出 baseUrl
export const baseUrl = getBaseUrl();

// 调试信息
console.log('Config baseUrl:', baseUrl, 'Environment:', process.env.NODE_ENV);

export default {
  baseUrl,
  getBaseUrl
};



// WEBPACK FOOTER //
// ./src/libs/config.js